import { render, staticRenderFns } from "./SuppliersBookingSettingsCancel.vue?vue&type=template&id=51b78140&"
import script from "./SuppliersBookingSettingsCancel.vue?vue&type=script&lang=js&"
export * from "./SuppliersBookingSettingsCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports